module.exports = __webpack_public_path__ + "static/media/doorbell.bf1026d5.png";